export default __webpack_public_path__ + "static/media/cnh.245f2e99.jpeg";